import type { Quantity } from './Quantity';
import type { Campaign } from './Campaign';

export type PurchaseModeString = string;

/**
 * Purchase Mode
 */
export enum PurchaseMode {
  BID = 'BID',
  INSTANT = 'INSTANT',
}

/**
 * Payment Option
 */
export enum PaymentOption {
  CASH = 'CASH',
  POINTS = 'POINTS',
}

/**
 * Purchase Options
 */
export type PurchaseOption = BidPurchaseOption | InstantPurchaseOption;

export interface BidPurchaseOption {
  purchaseMode: PurchaseMode.BID;
  paymentOption: PaymentOption;
  settings: PurchaseOptionSettings;
  encryptedSettings: string;
  quantity: Quantity;
  paymentBreakdown: PaymentBreakdown;
  encryptedPaymentBreakdown: string;
  partnerId: number;
  campaign?: Campaign;
}

export interface InstantPurchaseOption {
  purchaseMode: PurchaseMode.INSTANT;
  paymentOption: PaymentOption;
  settings: PurchaseOptionSettings /** start, min, max always equal amount and step always equal 0 */;
  encryptedSettings: string;
  quantity: Quantity;
  paymentBreakdown: PaymentBreakdown;
  encryptedPaymentBreakdown: string;
  partnerId: number;
  campaign?: Campaign;
}

export interface PaymentBreakdown {
  amount: number;
  baseAmount: number;
  taxes: Array<Tax>;
  fees: Array<Fee>;
}

export interface PurchaseOptionSettings {
  start: number;
  min: number;
  max: number;
  step: number;
  loadFactor?: number;
  loadFactorMultiplier?: number;
  fixedPrice?: boolean /** Flag for DSB bidding components to determine which variation gets rendered (Fixed vs Sliders) */;
  continuousPricing?: ContinuousPricing;
}

export type ContinuousPricing = {
  delta: number;
  trackingUuid: string;
} | null;

export type FeeCode = string;

export interface Fee {
  code: FeeCode;
  amount: number;
  taxes: Array<Tax>;
}

export type TaxCode = string;

export interface Tax {
  currency: string;
  amount: number;
  taxCode: TaxCode;
  country: string; // if we use the CountryCode we have a typescript error
}
